var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 118,
    viewBox: "0 0 212 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6914 17.6796V24.2496",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7305 13.6396V26.2696",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.252 10.0996V29.8096",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2422 22.2296V15.6596",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2109 26.2696V13.6396",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2305 17.6796V24.2496",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2598 13.6396V26.2696",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.791 10.0996V29.8096",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7695 22.2296V15.6596",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7402 26.2696V13.6396",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7715 17.6796V24.2496",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8008 13.6396V26.2696",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3223 10.0996V29.8096",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3125 22.2296V15.6596",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2812 26.2696V13.6396",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.890625 45.3808V51.9408",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92969 41.3308V53.9608",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45117 37.8008V57.5008",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4414 49.9208V43.3508",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41016 53.9608V41.3308",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4297 45.3808V51.9408",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.459 41.3308V53.9608",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9902 37.8008V57.5008",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9688 49.9208V43.3508",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9395 53.9608V41.3308",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9707 45.3808V51.9408",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 41.3308V53.9608",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5215 37.8008V57.5008",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5117 49.9208V43.3508",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4805 53.9608V41.3308",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.822 17.2601C204.422 9.06008 198.282 1.94008 190.082 1.33008",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.869 63.2512L119.59 68.0312L124.37 76.3102L132.649 71.5302L127.869 63.2512Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0366 30.2613L91.5859 28.5176L89.8422 32.9682L94.2929 34.712L96.0366 30.2613Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3314 7.21L81.3615 3L80.6914 10.28L87.3314 7.21Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.762 117C176.392 117 176.032 116.86 175.752 116.58C175.192 116.02 175.192 115.12 175.752 114.56L178.372 111.94C178.932 111.38 179.832 111.38 180.392 111.94C180.952 112.5 180.952 113.4 180.392 113.96L177.772 116.58C177.502 116.86 177.132 117 176.762 117Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.131 9.50961C139.108 9.50961 140.711 7.90679 140.711 5.92961C140.711 3.95243 139.108 2.34961 137.131 2.34961C135.154 2.34961 133.551 3.95243 133.551 5.92961C133.551 7.90679 135.154 9.50961 137.131 9.50961Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.971 15.5898L124.031 28.3398",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.281 103.28L208.951 84.4805",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.041 77.19L209.151 76.25",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2207 76.8594C71.7007 77.9494 73.4407 78.6194 75.2107 79.1194C79.2707 80.2594 83.7008 80.4894 87.6808 79.0694C91.6508 77.6394 95.0907 74.3894 96.0807 70.2894C97.0707 66.1894 95.2108 61.3794 91.4008 59.5494C89.1908 58.4894 86.5807 58.4694 84.2007 59.0794C83.0207 59.3794 81.8607 59.8394 80.9507 60.6494C78.0907 63.1794 79.0408 68.2594 82.0308 70.6294C85.0108 73.0094 89.1907 73.2294 92.9607 72.6794C96.3707 72.1794 99.9007 71.0094 102.091 68.3394C103.221 66.9694 103.911 65.2894 104.401 63.5794C105.491 59.8094 105.641 55.6694 104.191 52.0194C102.881 48.7294 100.131 45.9294 96.7607 44.9294",
    stroke: "#FFA940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0906 43.7895L97.0306 45.0195L98.2706 47.0695L96.8706 46.7195L95.6406 44.6695L97.6906 43.4395L99.0906 43.7895Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.441 99.5809V114.401H139.441V99.5809L143.651 91.7109L132.241 99.2009H118.422",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0199 98.5391L46.0898 113.689",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.111 68.5198C154.111 68.5198 187.641 83.1498 210.061 45.9998",
    stroke: "#FFA940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.431 48.5698L209.881 46.2298L207.551 46.7798L208.311 45.5598L210.641 45.0098L211.191 47.3398L210.431 48.5698Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1 57.4699C155.594 57.4699 163.29 49.7737 163.29 40.2799C163.29 30.7861 155.594 23.0899 146.1 23.0899C136.606 23.0899 128.91 30.7861 128.91 40.2799C128.91 49.7737 136.606 57.4699 146.1 57.4699Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.991 55.2399C156.484 55.2399 164.181 47.5437 164.181 38.0499C164.181 28.5561 156.484 20.8599 146.991 20.8599C137.497 20.8599 129.801 28.5561 129.801 38.0499C129.801 47.5437 137.497 55.2399 146.991 55.2399Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.949 42.1399C145.959 45.6299 152.849 44.4099 156.339 39.3899",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.58 27.1699L139.22 30.0399L143.65 28.6699L142.05 33.0199L144.72 36.8099L140.09 36.6299L137.31 40.3399L136.05 35.8799L131.66 34.3899L135.52 31.8099L135.58 27.1699Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.199 25.7899L151.749 24.9199L153.619 20.6699L155.859 24.7299L160.469 25.1899L157.299 28.5699L158.289 33.0999L154.089 31.1299L150.089 33.4799L150.659 28.8799L147.199 25.7899Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.689 13.6705L174.76 5.23047L182.479 6.21047L181.41 14.6505",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.626 14.8005C174.736 13.9293 173.88 13.1031 172.712 12.9551C171.545 12.8071 170.51 13.3934 170.399 14.2646C170.289 15.1358 171.145 15.9619 172.312 16.1099C173.479 16.2579 174.515 15.6717 174.626 14.8005Z",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.999 15.7336C182.109 14.8624 181.253 14.0362 180.085 13.8882C178.918 13.7402 177.883 14.3265 177.772 15.1977C177.662 16.0689 178.518 16.8951 179.685 17.043C180.853 17.191 181.888 16.6048 181.999 15.7336Z",
    stroke: "#FFA940",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7695 50.9195L61.1895 42.7695L68.6595 44.9895L66.2295 53.1395",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5133 52.2216C59.764 51.38 59.0533 50.4254 57.9259 50.0895C56.7984 49.7537 55.6812 50.1637 55.4305 51.0054C55.1798 51.847 55.8905 52.8014 57.018 53.1373C58.1454 53.4731 59.2626 53.0632 59.5133 52.2216Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6461 54.3544C66.8968 53.5128 66.1861 52.5582 65.0587 52.2223C63.9312 51.8865 62.814 52.2966 62.5633 53.1382C62.3126 53.9798 63.0233 54.9342 64.1508 55.2701C65.2782 55.606 66.3954 55.196 66.6461 54.3544Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicRightImage);
export default __webpack_public_path__ + "static/media/musicRightImage.ec7eb66f2ef9e22d52ecc399dbd47621.svg";
export { ForwardRef as ReactComponent };